/**
 * A regra que liga FORMA DE PAGAMENTO e CONDIÇÃO DE PARCELAMENTO.
 *
 * Forma à vista (Dinheiro, Pix, Cartão de Débito) só combina com condição de uma vez;
 * forma a prazo combina com todas as outras. Quem paga no Pix não paga em 3x.
 *
 * ESTAVA SÓ NA GUIA FINANCEIRO DO PEDIDO, e a tela de devolução precisa da mesma regra —
 * por isso virou arquivo. Duas cópias da mesma regra divergem no primeiro ajuste que
 * alguém fizer só de um lado.
 */

/**
 * Formas consideradas à vista, por PALAVRA-CHAVE e não por igualdade, para que variações
 * do cadastro ("PIX Banco X", "Dinheiro/espécie") continuem sendo reconhecidas.
 *
 *   "Dinheiro"            -> DINHEIRO
 *   "Pix"                 -> PIX
 *   "Cartão de Débito"    -> DEBITO   (e "Cartão de Crédito" não casa, como deve ser)
 */
const DESCRICOES_FORMA_AVISTA = ['DINHEIRO', 'PIX', 'DEBITO'];

/**
 * Mesma definição do backend (PROC_NOTA_FISCAL_GRAVAR grava pag_t_pag_a_vista com
 * IIF(cpg_id = 1, 1, 0)). Se um dia mudar, são estes DOIS pontos — e o correto seria
 * trocar os dois por "1 parcela com 0 dias", que a FN_CONDICAOPAGAMENTO_PARCELAS já sabe
 * responder.
 */
export const CPG_ID_AVISTA = 1;

const normalizarTexto = (texto: any) =>
  String(texto ?? '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '') // tira acentos: Débito -> Debito
    .toUpperCase()
    .trim();

/** A descrição da forma de pagamento é de uma forma à vista? */
export const descricaoEhFormaAvista = (descricao: any) => {
  const texto = normalizarTexto(descricao);
  if (!texto) return false;
  return DESCRICOES_FORMA_AVISTA.some((chave) => texto.includes(chave));
};

/** A condição de id informado é a de uma vez? */
export const condicaoEhAvista = (cpgId: any) => Number(cpgId) === CPG_ID_AVISTA;

/**
 * Aplica a regra a uma lista de condições, devolvendo cada opção com `disabled`.
 *
 * Sem forma escolhida, TUDO fica desabilitado: é a forma que destrava a condição.
 */
export const condicoesPermitidas = (
  condicoes: { value: any; label: string }[],
  formaSelecionadaEhAvista: boolean,
  temFormaSelecionada: boolean
) =>
  condicoes.map((opcao) => ({
    ...opcao,
    disabled:
      !temFormaSelecionada || condicaoEhAvista(opcao.value) !== formaSelecionadaEhAvista,
  }));
